<template>
  <v-card style='text-align:left'>
    <v-layout row >
      <v-flex xs2 pt-3 mx-2>
        <label class='prompt'>Primary Name</label>
      </v-flex>
      <v-flex xs3 mx-2>
          <v-text-field v-model="person.firstNames" name='firstNames' label="First names" />
      </v-flex>
      <v-flex xs3 >
          <v-text-field v-model="person.surname" name='surname' label="Surname" :rules="[ needed ]" />
            <!-- :rules="[rules.required, rules.min]" -->
      </v-flex>
    </v-layout> 

    <v-layout v-if="!person.otherNames || (person.otherNames.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Other name</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("otherNames", -1, {surname: "", firstNames: ""})'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>

    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Other Name</label>
      </v-flex>
      <v-flex xs10 >
        <v-layout column v-for="(otherName, index) in person.otherNames" v-bind:key="otherName.rid">
          <v-flex xs12 >
          <v-layout >
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 mx-2><v-text-field v-focus autofocus v-model="otherName.firstNames" name='firstNames' label="First names" /></v-flex>
                <v-flex xs4><v-text-field v-model="otherName.surname" name='surname' label="Surname" :rules="[ needed ]" /></v-flex>
                <v-flex xs4 pt-3>       
                  <v-icon  small  @click='delProp("otherNames", index)' >delete</v-icon>
                  <v-icon  small @click='addMultiOccuringProp("otherNames", index, {surname: "", firstNames: ""})'>add</v-icon>
                  <v-icon v-if="index > 0"  small   @click='up(person.otherNames, index)'>arrow_upward</v-icon>
                  <v-icon v-if="index < (person.otherNames.length - 1)"  small  @click='down(person.otherNames, index)'>arrow_downward</v-icon>
                  <v-icon v-if="!(otherName.scopeFrom || otherName.scopeTo)"  small  @click='addDateRange("otherNames", index)'>date_range</v-icon>
                </v-flex>
              </v-layout>
            </v-flex>  
          </v-layout>       
          </v-flex>
          <v-flex xs12 >
            <v-layout v-if="otherName.scopeFrom || otherName.scopeTo">            
              <v-flex xs12 ml-2>
                Start <input type="date" v-model="otherName.scopeFrom"/> End <input type="date" v-model="otherName.scopeTo"/>         
                <v-icon  small  @click='delDateRange("otherNames", index)'>delete</v-icon>
              </v-flex>
            </v-layout>   
          </v-flex>      
      </v-layout>      
      </v-flex>  
     </v-layout>

    <v-layout row v-if="!person.birthDate">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Birth Date</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("birthDate", "1910-01-31")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Birth Date</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
         <EditDateMaybeRange v-bind:container='person' v-bind:dateProp="'birthDate'"/>
         <!-- input type="date" v-model="person.birthDate"/ --> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("birthDate")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.birthPlace">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Birth Place</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("birthPlace", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Birth Place</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete  v-focus autofocus v-model="bp.select" :items="bp.places" item-text="pn" item-value="id"
          :search-input.sync="bpSearch" :loading="bp.loading" single-line  return-object>     
        </v-autocomplete>
        <v-layout row v-if="person.birthPlace.extra">
          <v-flex xs10>
              <v-text-field v-model="person.birthPlace.extra" label="Street/Locality"/>
          </v-flex>
          <v-flex xs2>
              <v-icon  small  @click='delPlaceExtra("birthPlace")' >delete</v-icon>              
          </v-flex>
        </v-layout> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("birthPlace")'>delete</v-icon>
        <v-icon v-if="(!person.birthPlace.extra)"  small  @click='addPlaceExtra("birthPlace")'>place</v-icon>        
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.addressAtEnlistment">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Address at Enlistment</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("addressAtEnlistment", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Address at Enlistment</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete v-focus autofocus v-model="eap.select" :items="eap.places" item-text="pn" item-value="id"
          :search-input.sync="eapSearch" :loading="eap.loading" single-line  return-object>     
        </v-autocomplete>
        <v-layout row v-if="person.addressAtEnlistment.extra">
          <v-flex xs10>
              <v-text-field v-model="person.addressAtEnlistment.extra" label="Street/Locality"/>
          </v-flex>
          <v-flex xs2>
              <v-icon  small  @click='delPlaceExtra("addressAtEnlistment")' >delete</v-icon>              
          </v-flex>
        </v-layout>        
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("addressAtEnlistment")'>delete</v-icon>
        <v-icon v-if="(!person.addressAtEnlistment.extra)"  small  @click='addPlaceExtra("addressAtEnlistment")'>place</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>     

    <v-layout v-if="!person.nok || (person.nok.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Next of Kin</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("nok", -1, {role: "", surname: "", firstNames: ""})'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Next of Kin</label>
      </v-flex>
      <v-flex xs10 >
        <v-layout column v-for="(nok, index) in person.nok" v-bind:key="nok.rid">
          <v-flex xs12 >
            <v-layout column>
              <v-flex xs12>
                <v-layout row>
                  <v-flex xs2 mx-2><v-combobox v-focus autofocus v-model="nok.role"  label="Their role" :items="nokRoleValues"></v-combobox></v-flex>
                  <v-flex xs3><v-text-field v-model="nok.firstNames" name='firstNames' label="First names" /></v-flex>
                  <v-flex xs3><v-text-field v-model="nok.surname" name='surname' label="Surname" :rules="[ needed ]" /></v-flex>
                  <v-flex xs4 pt-3>       
                    <v-icon  small  @click='delProp("nok", index)' >delete</v-icon>
                    <v-icon v-if="index === 0" small @click='addMultiOccuringProp("nok", index, {role: "", surname: "", firstNames: ""})'>add</v-icon>
                    <v-icon v-if="index > 0"  small   @click='up(person.nok, index)'>arrow_upward</v-icon>
                    <v-icon v-if="index < (person.nok.length - 1)"  small  @click='down(person.nok, index)'>arrow_downward</v-icon>
                    <v-icon v-if="!(nok.scopeFrom || nok.scopeTo)"  small  @click='addDateRange("nok", index)'>date_range</v-icon>
                    <v-icon v-if="!(nok.address)"  small  @click='addAddress("nok", index)'>place</v-icon>                  
                  </v-flex>
                </v-layout>
              </v-flex> 

              <v-flex xs12 >
                <v-layout v-if="nok.scopeFrom || nok.scopeTo">            
                  <v-flex xs12 ml-2>
                    Start <input type="date" v-model="nok.scopeFrom"/> End <input type="date" v-model="nok.scopeTo"/>         
                    <v-icon  small  @click='delDateRange("nok", index)'>delete</v-icon>
                  </v-flex>
                </v-layout>   
              </v-flex>  

              <v-flex xs12 >
                <v-layout v-if="nok.address" col justify-start>
                  <v-flex xs2 pt-3  mx-2>
                    <label class='prompt'>Address</label>
                  </v-flex>
                  <v-flex xs10>
                    <v-layout row>
                      <v-flex xs8 mx-2>

                        <v-layout row>
                          <v-flex xs10>
                            <v-text-field v-focus autofocus v-model="nok.address.extra" label="Street/Locality"/>
                          </v-flex>
                        </v-layout> 
                        <!-- array version didnt get updated reactively so gave up -->
                        <template v-if="index === 0">
                        <v-autocomplete   v-model="np0.select" :items="np0.places" item-text="pn" item-value="id"
                          :search-input.sync="npSearch0" :loading="np0.loading" single-line  return-object>     
                        </v-autocomplete>
                        </template>
                        <template v-if="index === 1">
                        <v-autocomplete  v-model="np1.select" :items="np1.places" item-text="pn" item-value="id"
                          :search-input.sync="npSearch1" :loading="np1.loading" single-line  return-object>     
                        </v-autocomplete>
                        </template>                        
    
                      </v-flex>
                      <v-flex xs4 pt-3>       
                        <v-icon  small  @click='delProp("nok", index, "address")'>delete</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>       
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- 
    <v-layout row v-if="!person.birthPlace">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Birth Place</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("birthPlace", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Birth Place</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete  v-model="bp.select" :items="bp.places" item-text="pn" item-value="id"
          :search-input.sync="bpSearch" :loading="bp.loading" single-line  return-object>     
        </v-autocomplete>
        <v-layout row v-if="person.birthPlace.extra">
          <v-flex xs10>
              <v-text-field v-model="person.birthPlace.extra" label="Street/Locality"/>
          </v-flex>
          <v-flex xs2>
              <v-icon  small  @click='delPlaceExtra("birthPlace")' >delete</v-icon>              
          </v-flex>
        </v-layout> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("birthPlace")'>delete</v-icon>
        <v-icon v-if="(!person.birthPlace.extra)"  small  @click='addPlaceExtra("birthPlace")'>place</v-icon>        
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 
    -->

    <!--  moved to NOK
    <v-layout row v-if="!person.NOKPlace">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Next of Kin Address</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("NOKPlace", {rid: -1})'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Next of Kin Address</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete  v-model="np.select" :items="np.places" item-text="pn" item-value="id"
          :search-input.sync="npSearch" :loading="np.loading" single-line  return-object>     
        </v-autocomplete>
        <v-layout row v-if="person.NOKPlace.extra">
          <v-flex xs10>
              <v-text-field v-model="person.NOKPlace.extra" label="Street/Locality"/>
          </v-flex>
          <v-flex xs2>
              <v-icon  small  @click='delPlaceExtra("NOKPlace")' >delete</v-icon>              
          </v-flex>
        </v-layout> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("NOKPlace")'>delete</v-icon>
        <v-icon v-if="(!person.NOKPlace.extra)"  small  @click='addPlaceExtra("NOKPlace")'>place</v-icon>        
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 
    -->

    <v-layout row v-if="!person.occupation || (person.occupation.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Occupation</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("occupation", -1, null, "oc", "Labourer")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Occupation</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(occupation, index) in person.occupation" v-bind:key="occupation.rid">
          <v-flex xs8 mx-2>
            <v-autocomplete v-focus autofocus v-model="person.occupation[index]" :items="$constants.codeValues.oc" item-text="v" item-value="id" return-object single-line>
            </v-autocomplete>  
            <template v-if="occupation.scopeFrom || occupation.scopeTo">
              Start <input type="date" v-model="occupation.scopeFrom"/> End <input type="date" v-model="occupation.scopeTo"/>         
              <v-icon  small  @click='delDateRange("occupation", index)' >delete</v-icon>
            </template>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("occupation", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("occupation", index, null, "oc", "Labourer")'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.occupation, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.occupation.length - 1)"  small  @click='down(person.occupation, index)'>arrow_downward</v-icon>
            <v-icon v-if="!(occupation.scopeFrom || occupation.scopeTo)"  small  @click='addDateRange("occupation", index)'>date_range</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>        

    <v-layout row v-if="!person.religion || (person.religion.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Religion</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("religion", -1, null, "fth", "Church of England")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Religion</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(religion, index) in person.religion" v-bind:key="religion.rid">
          <v-flex xs8 mx-2>
            <!-- v-select v-model="person.religion[index]" :items="$constants.codeValues.fth" item-text="v" item-value="id" return-object single-line>
            </v-select -->  
            <v-autocomplete v-focus autofocus v-model="person.religion[index]" :items="$constants.codeValues.fth" item-text="v" item-value="id" return-object single-line>
            </v-autocomplete> 
            <template v-if="religion.scopeFrom || religion.scopeTo">
              Start <input type="date" v-model="religion.scopeFrom"/> End <input type="date" v-model="religion.scopeTo"/>         
              <v-icon  small  @click='delDateRange("religion", index)' >delete</v-icon>
            </template>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("religion", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("religion", index, null, "fth", "Church of England")'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.religion, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.religion.length - 1)"  small  @click='down(person.religion, index)'>arrow_downward</v-icon>
            <v-icon v-if="!(religion.scopeFrom || religion.scopeTo)"  small  @click='addDateRange("religion", index)'>date_range</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row v-if="!person.gender || (person.gender.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Gender</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringCodeProp("gender", "ge", "Male")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Gender</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-radio-group v-focus autofocus v-model="person.gender[0].id" row> <!-- @change="genderChanged" -->
          <v-radio  v-for="genderCode in $constants.codeValues.ge" v-bind:key="genderCode.id" :label="genderCode.v"
            :value="genderCode.id">
          </v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("gender")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>    

    <v-layout row v-if="!person.maritalStatus || (person.maritalStatus.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Marital Status</label><v-btn flat fab  small mt-4  middle @click='addMultiOccuringProp("maritalStatus", -1, null, "ms", "Single")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Marital Status</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(maritalStatus, index) in person.maritalStatus" v-bind:key="maritalStatus.rid">
          <v-flex xs8 mx-2>
            <v-autocomplete v-focus autofocus v-model="person.maritalStatus[index]" :items="$constants.codeValues.ms" item-text="v" item-value="id" return-object single-line>
            </v-autocomplete>  
            <template v-if="maritalStatus.scopeFrom || maritalStatus.scopeTo">
              Start <input type="date" v-model="maritalStatus.scopeFrom"/> End <input type="date" v-model="maritalStatus.scopeTo"/>         
              <v-icon  small  @click='delDateRange("maritalStatus", index)' >delete</v-icon>
            </template>
          </v-flex>
          <v-flex xs4 pt-3   >       
            <v-icon  small  @click='delProp("maritalStatus", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("maritalStatus", index, null, "ms", "Single")'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.maritalStatus, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.maritalStatus.length - 1)"  small  @click='down(person.maritalStatus, index)'>arrow_downward</v-icon>
            <v-icon v-if="!(maritalStatus.scopeFrom || maritalStatus.scopeTo)"  small  @click='addDateRange("maritalStatus", index)'>date_range</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.eyeColour || (person.eyeColour.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Eye Colour</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringCodeProp("eyeColour", "ec", "Blue")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Eye Colour</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete v-focus autofocus v-model="person.eyeColour[0]" :items="$constants.codeValues.ec" item-text="v" item-value="id" return-object single-line>
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("eyeColour")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  

    <v-layout row v-if="!person.hairColour || (person.hairColour.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Hair Colour</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringCodeProp("hairColour", "hc", "Brown")'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Hair Colour</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete v-focus autofocus v-model="person.hairColour[0]" :items="$constants.codeValues.hc" item-text="v" item-value="id" return-object single-line>
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("hairColour")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  

    <v-layout row v-if="!person.height || (person.height.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Height</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("height", [{rid: -1, v:160}])'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Height</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete v-focus autofocus v-model="person.height[0].v" :items="this.heights" item-text="str" item-value="v" single-line counter="200">
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("height")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.weight || (person.weight.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Weight</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("weight", [{rid: -1, v:140}])'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Weight</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2>
        <v-autocomplete v-focus autofocus v-model="person.weight[0].v" :items="this.weights" item-text="str" item-value="v" single-line counter="200">
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("weight")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- moved to fate postwar
    <v-layout row v-if="!person.deathDate">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Death Date</label><v-btn flat fab  small mt-4  middle @click='addSinglyOccuringNoncodeProp("deathDate", "1970-12-31")'><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout col justify-start v-else>
      <v-flex xs2 pt-3  mx-2>
        <label class='prompt'>Death Date</label>
        </v-flex>
      <v-flex xs10>
        <v-layout row>
      <v-flex xs8 mx-2 mt-3>
          <input type="date" v-model="person.deathDate"/> 
      </v-flex>
      <v-flex xs4 pt-3>       
        <v-icon  small  @click='delProp("deathDate")' >delete</v-icon>
      </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 
    -->

  </v-card>
</template>        

<script>

import PlaceService from "@/services/PlaceService" ;
import EditDateMaybeRange from "./EditDateMaybeRange" ; 

export default {

  components: { PlaceService, EditDateMaybeRange },
  props: {
    person: null
  },

  data () {
    return {
      unit: {},
      weights: [ ],
      heights: [ ],
      addSeqForRid: -1,

      bp: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },
      bpSearch: null,

      eap: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },
      eapSearch: null,      

      // np: [],
      np0: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },
      np1: {
        select: {id: -1, pn: ""}, 
        places: [],
        loading: false,
        origId: -1,
        nextSearchFor: null
      },      
      npSearch0: null,
      npSearch1: null,

      nokRoleValues: ['Mother', 'Father', 'Brother', 'Sister', 'Wife', 'Husband', 'Fiance', 'Son', 'Daughter', 'Aunt', 'Uncle', 'Nephew', 'Niece',
        'Step-mother', 'Step-father', 'Step-son', 'Step-daughter', 'Friend', 'Cousin', 'Parent-in-law', 'Brother-in-law',
        'Sister-in-law', 'Former spouse', 'Other relative', 'Neighbour', 'Guardian', 'Foster mother', 'Foster father']  // role of the NOK eg Mother of soldier
      /*
      bpSelect: {id: -1, pn: ""},  // {pn: "ABC", id: 1},
      bpLoading: false,
      bpPlaces: [], // [{pn: "Alaskass", id:0}, {pn:"XssYZ", id:2}, {pn:"ABC", id:1}],
      bpSearch: null,
      bpOrigId: -1, // tracks change
      nextSearchFor: null
      */
    }
  },

  watch: {
    async bpSearch (val) {
      console.log("IN BP SEARCH val: " + val + ", this.bp.Select.pn=" + this.bp.select.pn) ;
      if (val && val !== this.bp.select.pn && (val.length >= 2)) {
        this.placeQuerySelections(val, this.bp) ;
      }
    },
    async npSearch0 (val) {
      console.log("IN NP0 SEARCH val: " + val + ", this.np0.Select.pn=" + this.np0.select.pn + " id=" + this.np0.select.id) ;
      if (val && val !== this.np0.select.pn && (val.length >= 2)) {
        this.placeQuerySelections(val, this.np0) ;
      }
    },    
    async npSearch1 (val) {
      console.log("IN NP1SEARCH val: " + val + ", this.np1.Select.pn=" + this.np1.select.pn) ;
      if (val && val !== this.np1.select.pn && (val.length >= 2)) {
        this.placeQuerySelections(val, this.np1) ;
      }
    }, 
    async eapSearch (val) {
      console.log("IN EAP SEARCH val: " + val + ", this.eapSelect.pn=" + this.eap.select.pn) ;
      if (val && val !== this.eap.select.pn && (val.length >= 2)) {
        this.placeQuerySelections(val, this.eap) ;
      }
    },     
    
    person: function (val) {
      // this.person = val ;
      this.updateBP() ;
    }    
  },  

  mounted () {
    // console.log("MainNames in mounted, person =" +  JSON.stringify(this.person)) ;

  },
  beforeUpdate () {
    // console.log("MainNames in beforeUpdate1, person =" +  JSON.stringify(this.person)) ;
  },
  updated () {
    // console.log("MainNames in updated, person =" +  JSON.stringify(this.person)) ;
    
    // this.bpPlaces = [{pn: "Alaskasszzz", id:0}, {pn:"XssYzzzzzzzzzZ", id:2}, {pn:"ABC", id:1}] ;    
  },  
  beforeMount () {
    // console.log("MainNames in beforeMount, person =" +  JSON.stringify(this.person)) ;
  }, 
  created () {
    for (var pounds = 70 ; pounds < 280 ; pounds++) {
      const centigrams = Math.round(pounds / 0.220462) ;
      this.weights.push({ v: centigrams, str: this.$renderWeight(centigrams) }) ;      
    } ;
    for (var halfInches = 96 ; halfInches < 165 ; halfInches++) {
      const cm = Math.round(halfInches * 2.54 / 2) ;
      this.heights.push({ v: cm, str: this.$renderHeight(cm) }) ;      
    } ;
  },

  methods: {

    updateBP () {

      console.log("PERDET TAB in UPDATEBP") ;
      this.updatePlace(this.bp, this.person.birthPlace) ;
      this.updatePlace(this.eap, this.person.addressAtEnlistment) ;

      if (this.person.nok) {
        console.log("this.person.nok=" + JSON.stringify(this.person.nok)  + " length=" + this.person.nok.length) ;
        
        if (this.person.nok.length > 0) this.updatePlace(this.np0, this.person.nok[0].address) ;
        if (this.person.nok.length > 1) this.updatePlace(this.np1, this.person.nok[1].address) ;
        /*
        for (let i = 0 ; i < this.person.nok.length ; i++) {
          const locp = { select: {id: -1, pn: ""},  places: [],  loading: false,   origId: -1, nextSearchFor: null } ;
          const dbp = this.person.nok[i].address ;
          this.updatePlace(locp, dbp) ;
          this.np[i] = locp ;
        }
        console.log("---------- SET NP TO " + JSON.stringify(this.np)) ;
        */
      }
      // else this.np = [] ;
      // this.updatePlace(this.np, this.person.NOKPlace) ; // TODO
    },

    updatePlace (locp, dbp) {

      if (dbp && dbp.rid) {
        locp.select.id = -1 ; 
        if (dbp.town) {
          locp.select.id = dbp.town.id ;
          locp.select.pn = dbp.town.v ;
          if (dbp.state) locp.select.pn += ", " + dbp.state.v ;
          if (dbp.country) locp.select.pn += ", " + dbp.country.v ;
        }
        else if (dbp.state) {
          locp.select.id = dbp.state.id ;
          locp.select.pn = dbp.state.v ;
          if (dbp.country) locp.select.pn += ", " + dbp.country.v ;
        }
        else if (dbp.country) {
          locp.select.id = dbp.country.id ;
          locp.select.pn = dbp.country.v ; 
        }
        else {
          locp.select.id = -1 ; 
          locp.select.pn = "" ; 
        }
        locp.origId =  locp.select.id ;
        locp.places = [ locp.select ] ;
        console.log("Set this.bp/npPlaces=" + JSON.stringify(locp.places)) ;
      }
    },
    /*
    updateBP () {

      console.log("MainNames in UPDATEBP, person =" +  JSON.stringify(this.person)) ;

      const bp = this.person.birthPlace ; 
      if (bp && bp.rid) {
        this.bpSelect.id = -1 ; 
        if (bp.town) {
          this.bpSelect.id = bp.town.id ;
          this.bpSelect.pn = bp.town.v ;
          if (bp.state) this.bpSelect.pn += ", " + bp.state.v ;
          if (bp.country) this.bpSelect.pn += ", " + bp.country.v ;
        }
        else if (bp.state) {
          this.bpSelect.id = bp.state.id ;
          this.bpSelect.pn = bp.state.v ;
          if (bp.country) this.bpSelect.pn += ", " + bp.country.v ;
        }
        else if (bp.country) {
          this.bpSelect.id = bp.country.id ;
          this.bpSelect.pn = bp.country.v ; 
        }
        else {
          this.bpSelect.id = -1 ; 
          this.bpSelect.pn = "" ; 
        }
        this.bpOrigId =  this.bpSelect.id ;
        this.bpPlaces = [ this.bpSelect ] ;
        console.log("Set this.bpPlaces=" + JSON.stringify(this.bpPlaces)) ;
      }
    },
    */

    finaliseUpdates () {

      console.log("===========================> PD finaliseUpdates") ;
      // check the birthplace
      if (this.person.birthPlace && (this.bp.origId !==  this.bp.select.id)) {  // changed (and not just deleted)
        console.log("Set newId..") ;
        this.person.birthPlace.newId = this.bp.select.id ; // will force updater to do the work of rebuilding - we dont worry about town/state/country ids
      }
      if (this.person.addressAtEnlistment && (this.eap.origId !==  this.eap.select.id)) {  // changed (and not just deleted)
        console.log("Set addressAtEnlistment newId..") ;
        this.person.addressAtEnlistment.newId = this.eap.select.id ; // will force updater to do the work of rebuilding - we dont worry about town/state/country ids
      }   
      if (this.person.nok && this.person.nok[0] && this.person.nok[0].address && (this.np0.origId !==  this.np0.select.id)) {  // changed (and not just deleted)
        console.log("Set NOK PLACE 0 newId..") ;
        this.person.nok[0].address.newId = this.np0.select.id ; // will force updater to do the work of rebuilding - we dont worry about town/state/country ids
      }  
      if (this.person.nok && this.person.nok[1] && this.person.nok[1].address && (this.np1.origId !==  this.np1.select.id)) {  // changed (and not just deleted)
        console.log("Set NOK PLACE 1 newId..") ;
        this.person.nok[1].address.newId = this.np1.select.id ; // will force updater to do the work of rebuilding - we dont worry about town/state/country ids
      }             
    },

    async placeQuerySelections (val, locp) {

      /*
      if (!val) {
        val = locp.nextSearchFor ;
        locp.nextSearchFor = null ;
        console.log("TAKEN PQS from queue next search for " + val) ;
      }

      if (locp.loading) {
        console.log("PQS in progress - deferring " + val) ;
        locp.nextSearchFor = val ;
        return ;
      }
      */
      console.log("placeQuerySelections val: " + val) ;
      locp.loading = true ;
      try {
        const response = await PlaceService.placeFindMatchesOnName(val, true) ;
        console.log("PlaceService responded") ; // + JSON.stringify(response)) ;

        locp.places = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        console.log(" responded finally locp is " + JSON.stringify(locp)) ;
        locp.loading = false ;
        /*
        this.$set(locp, "loading", false) ;
        this.$set(this.np[0], "loading", false) ;
        this.$forceUpdate() ;
        */
      }
      /*
      if (locp.nextSearchFor) {
        console.log(" about to queue PQS " + locp.nextSearchFor) ;
        setTimeout(function () {
          this.placeQuerySelections(null, locp) ;
        }, 10) ;
      }
      */
    },
    /*
    async placeQuerySelections (val) {
      if (!val) {
        val = this.nextSearchFor ;
        this.nextSearchFor = null ;
        console.log("TAKEN PQS from queue next search for " + val) ;
      }

      if (this.bpLoading) {
        console.log("PQS in progress - deferring " + val) ;
        this.nextSearchFor = val ;
        return ;
      }
      console.log("placeQuerySelections val: " + val) ;
      this.bpLoading = true ;
      try {
        const response = await PlaceService.placeFindMatchesOnName(val) ;
        console.log("PlaceService responsed") ; // + JSON.stringify(response)) ;

        this.bpPlaces = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        this.bpLoading = false ;
      }
      if (this.nextSearchFor) {
        console.log(" about to queue PQS " + this.nextSearchFor) ;
        setTimeout(this.placeQuerySelections, 10) ;
      }
    },
    */

    needed (value) {
      console.log(" in needed, value is " + value)  ;
      if (value && value.length && (value.length > 0)) return true ;
      this.$emit('errorOnTab') ; 
      console.log("emmitted swap") ;
      return "Required" ;
    },

    addMultiOccuringProp (propName, index, record, propCode, defaultValue) {  // addMultiOccuringProp("otherNames", -1, {surname: "", firstNames: ""})

      if (!this.person[propName]) this.person[propName] = [] ;
      var newRec ;
      if (record) newRec = { ...record, rid: this.addSeqForRid-- } ; // a unique rid so as not to confuse keys - but it will be negative, so backend knows it is new
      else  {
        newRec = {...this.setDefaultOption(propCode, defaultValue), rid: this.addSeqForRid--} ;
      }

      console.log("in pdt addMultiOccuringProp " + record + " newRec " + JSON.stringify(newRec)) ;

      this.person[propName].splice(index + 1, 0, newRec) ;
      this.$forceUpdate() ;   // shouldnt have to do this.
      if (propName === "nok") this.updateBP() ;
    },

    addAddress (propName, index) {
      console.log("adding address to " + propName + "," + index) ;
      this.person[propName][index].address =  {rid: -1} ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delAddress (propName, index) {
      console.log("delete address to " + propName + "," + index) ;
      delete this.person[propName][index].address ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },    

    addDateRange (propName, index) {
      console.log("adding date range to " + propName + " at " + index) ;
      this.person[propName][index].scopeFrom = "1900-01-01" ;
      this.person[propName][index].scopeTo = "1900-12-31" ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delDateRange (propName, index) {
      console.log("delete date range to " + propName + " at " + index) ;
      delete this.person[propName][index].scopeFrom  ;
      delete this.person[propName][index].scopeTo ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    up (arr, ix) {  // take entry at ix and move it to ix-1
      console.log("UpA " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix - 1] ;
      arr[ix - 1] = x ;
      console.log("UpB " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      this.$forceUpdate() ;

    },
    down (arr, ix) {
      console.log("downA " + ix + "  arr:" + JSON.stringify(arr)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix + 1] ;
      arr[ix + 1] = x ;
      console.log("downB " + ix + "  arr:" + JSON.stringify(arr)) ; 
      this.$forceUpdate() ;
    },

    setDefaultOption (codeType, defaultValue) {
      const glist = this.$constants.codeValues[codeType] ; 
      for (var i = 0 ; i < glist.length ; i++) {
        if (glist[i].v === defaultValue) {
          return { v: glist[i].v, id: glist[i].id } ;
        }
      }
      return { v: "No default", id: -1 } ;
    },

    delProp (propName, index, subPropName) {
      console.log("Del prop name " + propName + " subProp " + subPropName + " index " + index) ;
      if (subPropName) {
        if (index >= 0) delete this.person[propName][index][subPropName] ;
        else delete this.person[propName][subPropName] ;
      }
      else {
        if (index >= 0) this.person[propName].splice(index, 1) ;
        else delete this.person[propName] ;
      }
      this.$forceUpdate() ;
      if (propName === "nok") this.updateBP() ;
    },

    addSinglyOccuringNoncodeProp (propName, defaultValue) {
      this.person[propName] = defaultValue ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    },

    addSinglyOccuringCodeProp (propName, propCode, defaultValue) {  
      this.person[propName] = [ this.setDefaultOption(propCode, defaultValue) ] ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    },

    addPlaceExtra (propName) {
      console.log("adding placeextra to " + propName) ;
      this.person[propName].extra = " " ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },
    delPlaceExtra (propName) {
      console.log("adding placeextra to " + propName) ;
      delete this.person[propName].extra ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    }    
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/PersonalDetailsTab.vue